import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { useContext } from 'react'
import GeneralContext from '../contexts/GeneralContext'
import { useNavigate } from 'react-router-dom'

function FriendsTab() {
   const {setCurrentTab, currentTab, showFullSize} = useContext(GeneralContext)
   const navigator = useNavigate()
   const changeScreen = () => {
      setCurrentTab("Friends")
      navigator('/main/friends')
   }

   return (
      <div className="tab" onClick={changeScreen}>
         <div className={`innerTab ${(currentTab == 'Friends') && 'innerTabActive'}`}>
            <div className="iconTab">
               <FontAwesomeIcon icon={faUsers} className="iconTab" />
            </div>
            {showFullSize && <p className="tabText">Friends</p>}
         </div>
      </div>
   )
}
export default FriendsTab
